import { motion } from "framer-motion";
import { Droplets, Clock, ShieldAlert, Car } from "lucide-react";

const items = [
  {
    icon: Droplets,
    title: "Water restrictions",
    body:
      "Bangalore apartments ban open-hose washing. Most providers can't comply, leaving cars dusty for weeks.",
    span: "md:col-span-7",
    big: true,
  },
  {
    icon: Clock,
    title: "Time poverty",
    body: "Weekends shouldn't be spent at service centres.",
    span: "md:col-span-5",
  },
  {
    icon: ShieldAlert,
    title: "Trust deficit",
    body:
      "Damages go undocumented. No accountability when something scratches your hood.",
    span: "md:col-span-5",
  },
  {
    icon: Car,
    title: "Inconsistent quality",
    body:
      "One day it's a deep clean, the next it's a wipe-down. Premium cars deserve consistency.",
    span: "md:col-span-7",
  },
];

export default function Problem() {
  return (
    <section
      data-testid="problem-bento-section"
      className="relative py-24 md:py-32 px-6 md:px-12 bg-zyp-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16">
          <div className="text-xs uppercase tracking-[0.22em] text-zyp-navy/60 mb-4">
            The problem
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-zyp-navy">
            Car care, today, is broken for apartments.
          </h2>
          <p className="mt-4 text-zyp-navy/70 text-lg max-w-xl">
            Four pain points every premium-car owner in a Bangalore apartment
            has experienced. Quietly. Repeatedly.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {items.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`problem-card-${i}`}
              className={`${it.span} rounded-2xl border border-zyp-navy/10 bg-zyp-cream/30 hover:border-zyp-navy/20 hover:bg-zyp-cream/50 transition-all p-8 md:p-10 group relative overflow-hidden`}
            >
              <div className="absolute -top-10 -right-10 h-40 w-40 rounded-full bg-zyp-highlight/0 group-hover:bg-zyp-highlight/10 blur-3xl transition-all duration-700" />
              <it.icon
                size={it.big ? 38 : 30}
                className="text-zyp-highlight mb-6"
                strokeWidth={1.5}
              />
              <h3
                className={`font-heading font-medium tracking-tight text-zyp-navy ${
                  it.big ? "text-3xl md:text-4xl" : "text-2xl"
                }`}
              >
                {it.title}
              </h3>
              <p className="mt-3 text-zyp-navy/70 leading-relaxed max-w-md">
                {it.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
